import {
  ADD_NOTE_GUEST_CONTACT_FAILED,
  ADD_NOTE_GUEST_CONTACT_START,
  ADD_NOTE_GUEST_CONTACT_SUCCESS,
  CREATE_ACCOUNT_GUEST_CONTACT_FAILED,
  CREATE_ACCOUNT_GUEST_CONTACT_START,
  CREATE_ACCOUNT_GUEST_CONTACT_SUCCESS,
  CREATE_GUEST_CONTACT,
  CREATE_GUEST_CONTACT_FAILED,
  CREATE_GUEST_CONTACT_SUCCESS,
  GET_GUEST_CONTACT_DETAILS_FAILED,
  GET_GUEST_CONTACT_DETAILS_START,
  GET_GUEST_CONTACT_DETAILS_SUCCESS,
  RESET_GUEST_CONTACT_DETAIL_STATE,
  SEARCH_GUEST_CONTACT_FAILED,
  SEARCH_GUEST_CONTACT_START,
  SEARCH_GUEST_CONTACT_SUCCESS,
} from '../actions/contact'

const initialState = {
  isLoading: false,
  guestContactList: [],
  guestContactDetail: {},
  total: null,
}

export default function guestContact(state = initialState, action) {
  switch (action.type) {
    case CREATE_GUEST_CONTACT:
    case SEARCH_GUEST_CONTACT_START:
    case GET_GUEST_CONTACT_DETAILS_START:
    case ADD_NOTE_GUEST_CONTACT_START:
    case CREATE_ACCOUNT_GUEST_CONTACT_START:
      return {
        ...state,
        isLoading: true,
      }
    case SEARCH_GUEST_CONTACT_SUCCESS:
      return {
        ...state,
        guestContactList: action.payload.list,
        isLoading: false,
        total: action.payload.total,
      }
    case SEARCH_GUEST_CONTACT_FAILED:
      return {
        ...state,
        guestContactList: [],
        isLoading: false,
        total: 0,
      }
    case CREATE_GUEST_CONTACT_SUCCESS:
    case CREATE_GUEST_CONTACT_FAILED:
    case ADD_NOTE_GUEST_CONTACT_SUCCESS:
    case ADD_NOTE_GUEST_CONTACT_FAILED:
    case CREATE_ACCOUNT_GUEST_CONTACT_SUCCESS:
    case CREATE_ACCOUNT_GUEST_CONTACT_FAILED:
      return {
        ...state,
        isLoading: false,
      }
    case GET_GUEST_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        guestContactDetail: action.payload.data,
        isLoading: false,
      }
    case GET_GUEST_CONTACT_DETAILS_FAILED:
      return {
        ...state,
        guestContactDetail: {},
        isLoading: false,
      }
    case RESET_GUEST_CONTACT_DETAIL_STATE:
      return {
        ...state,
        guestContactDetail: {},
      }
    default:
      return state
  }
}
